import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>개인정보처리방침</h1>
        <p className="updated-date">시행일: 2025년 2월 1일</p>

        <section>
          <h2>1. 개인정보의 처리 목적</h2>
          <p>와우오더(이하 '회사')는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
          <ul>
            <li>서비스 제공: QR 코드 기반 테이블 주문 서비스 제공 및 주문 처리</li>
            <li>회원 관리: 가맹점 회원 가입, 본인 확인, 서비스 이용 관리</li>
            <li>서비스 개선: 서비스 이용 통계 분석 및 서비스 품질 향상</li>
          </ul>
        </section>

        <section>
          <h2>2. 수집하는 개인정보 항목</h2>
          <p>회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.</p>
          <h3>가맹점 회원가입 시</h3>
          <ul>
            <li>필수항목: 이름, 이메일, 비밀번호, 사업자등록번호, 매장명, 매장 전화번호, 매장 주소</li>
          </ul>
          <h3>주문 서비스 이용 시</h3>
          <ul>
            <li>자동 수집 항목: 접속 IP, 접속 일시, 서비스 이용 기록</li>
          </ul>
        </section>

        <section>
          <h2>3. 개인정보의 보유 및 이용 기간</h2>
          <p>회사는 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계 법령에 의해 보존할 필요가 있는 경우 아래와 같이 관계 법령에서 정한 일정한 기간 동안 개인정보를 보관합니다.</p>
          <ul>
            <li>계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)</li>
            <li>대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)</li>
            <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)</li>
            <li>접속에 관한 기록: 3개월 (통신비밀보호법)</li>
          </ul>
        </section>

        <section>
          <h2>4. 개인정보의 제3자 제공</h2>
          <p>회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</p>
          <ul>
            <li>이용자가 사전에 동의한 경우</li>
            <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
          </ul>
        </section>

        <section>
          <h2>5. 개인정보의 파기 절차 및 방법</h2>
          <p>회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
          <ul>
            <li>전자적 파일 형태: 복구 및 재생이 불가능한 방법으로 영구 삭제</li>
            <li>종이 문서: 분쇄기로 분쇄하거나 소각하여 파기</li>
          </ul>
        </section>

        <section>
          <h2>6. 이용자의 권리와 행사 방법</h2>
          <p>이용자는 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
          <ul>
            <li>개인정보 열람 요구</li>
            <li>오류 등이 있을 경우 정정 요구</li>
            <li>삭제 요구</li>
            <li>처리정지 요구</li>
          </ul>
          <p>위 권리 행사는 회사에 대해 서면, 전화, 이메일 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체 없이 조치하겠습니다.</p>
        </section>

        <section>
          <h2>7. 개인정보의 안전성 확보 조치</h2>
          <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
          <ul>
            <li>비밀번호의 암호화 저장 및 관리</li>
            <li>해킹 등에 대비한 기술적 대책 (SSL/TLS 암호화 통신)</li>
            <li>개인정보 접근 권한 제한</li>
            <li>개인정보 취급 직원의 최소화 및 교육</li>
          </ul>
        </section>

        <section>
          <h2>8. 개인정보 보호책임자</h2>
          <div className="info-box">
            <p><strong>개인정보 보호책임자</strong></p>
            <p>성명: 박지훈</p>
            <p>직위: 대표</p>
            <p>이메일: official@woworder.kr</p>
          </div>
        </section>

        <section>
          <h2>9. 개인정보 처리방침 변경</h2>
          <p>이 개인정보처리방침은 2025년 2월 1일부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
        </section>
      </div>

      <style jsx>{`
        .privacy-container {
          min-height: 100vh;
          background-color: #f8f9fa;
          padding: 20px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }
        .privacy-content {
          max-width: 800px;
          margin: 0 auto;
          background: #fff;
          border-radius: 12px;
          padding: 40px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        }
        h1 {
          font-size: 28px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 8px 0;
          text-align: center;
        }
        .updated-date {
          text-align: center;
          color: #888;
          font-size: 14px;
          margin-bottom: 40px;
        }
        section {
          margin-bottom: 32px;
        }
        h2 {
          font-size: 18px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 12px 0;
          padding-bottom: 8px;
          border-bottom: 1px solid #eee;
        }
        h3 {
          font-size: 15px;
          font-weight: 600;
          color: #333;
          margin: 12px 0 8px 0;
        }
        p {
          font-size: 14px;
          line-height: 1.7;
          color: #444;
          margin: 0 0 8px 0;
        }
        ul {
          margin: 8px 0;
          padding-left: 20px;
        }
        li {
          font-size: 14px;
          line-height: 1.7;
          color: #444;
          margin-bottom: 4px;
        }
        .info-box {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 16px 20px;
        }
        .info-box p {
          margin: 4px 0;
        }
        @media (max-width: 600px) {
          .privacy-container {
            padding: 12px;
          }
          .privacy-content {
            padding: 24px 20px;
            border-radius: 8px;
          }
          h1 {
            font-size: 22px;
          }
          h2 {
            font-size: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPage;
